import styled from 'styled-components';

export const Faq = styled.section`
  padding: 5rem 0;
  background-image: linear-gradient(#fff, #F7FAFC);

  h2,
  details {
    position: relative;
  }
`;

export const Details = styled.details`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 16px 32px rgba(0,0,0, .05);
  margin-bottom: 1.5rem;
  transition: 150ms;
  transition-timing-function: ease-in-out;

  &:last-child {
    margin: 0;
  }

  &:hover {
    background: #F7FAFC;
  }

  &[open] {
    background: #F7FAFC;

    summary {
      border-bottom: 1px solid #E2E8F0;
    }

    summary::-webkit-details-marker {
      color: #C6F6D5;

    }
  }

  p {
    padding: 1.5rem 1.5rem 1.5rem 2.5rem;
  }
`;

export const Summary = styled.summary`
  padding: 1.5rem 1.5rem 1.5rem 2.5rem;
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  line-height: 1.2;
  outline: none;
  cursor: pointer;

  &::-webkit-details-marker {
    color: #46A85C;
    position: absolute;
    top: 50%;
    left: 1rem;
    margin-top: -6px;
  }
`;

export const Img = styled.img`
  position: absolute;
  top: -48px;
  left: 42%;
`
